import { axios as apiService } from '../axiosService';
import { BASE_URL } from './index';
import { queryURLParams } from '@utils/common';
import { getChatbotChatIdLogoutHeaders } from '../../aiChat/persistence/chatbotChatIdStorage';

export const SERVICE_URL = process.env.REACT_APP_common_service_api_url;

const getCommonCode = async () =>
  await apiService.get(`${BASE_URL}/common-service-portal-url`);

export const getCommonServiceTokenRequest = async () => {
  const code = await getCommonCode().then((data) => {
    if (!data) {
      return;
    }

    return data.split('code=')[1];
  });

  return await apiService.get(`${SERVICE_URL}/auth/v1/token?code=${code}`, {
    withCredentials: false,
  });
};

const commonServiceRequestWrapper = async (request) => {
  let { token } = queryURLParams(window.location.search, '&');

  if (!token) {
    const { token: { jwt } = {} } =
      (await getCommonServiceTokenRequest()) || {};
    token = jwt;
  }

  return await request({ jwt: token });
};

export const getWhiteListMemberListRequest = () =>
  commonServiceRequestWrapper((token) =>
    apiService.get(`${SERVICE_URL}/api/v1/pwc-employee`, {
      headers: {
        Authorization: `Bearer ${token?.jwt}`,
      },
      withCredentials: false,
    }),
  );

export const queryMemberByTextRequest = async (text) =>
  commonServiceRequestWrapper((token) => {
    if (!token?.jwt) {
      return [];
    }

    const queryText = String(text).replaceAll('/', '');

    if (queryText.length <= 0) {
      return [];
    }

    return apiService
      .get(
        `${SERVICE_URL}/public/v1/pwc-employee/searchByContent/${queryText}`,
        {
          headers: {
            Authorization: `Bearer ${token?.jwt}`,
          },
          withCredentials: false,
        },
      )
      .then((result) => result || []);
  });

export const submitAddedUsersRequest = async (items) =>
  commonServiceRequestWrapper((token) => {
    if (!token?.jwt) {
      return false;
    }
    return apiService.post(
      `${SERVICE_URL}/api/v1/pwc-employee`,
      { items },
      {
        headers: {
          Authorization: `Bearer ${token?.jwt}`,
        },
        withCredentials: false,
      },
    );
  });

export const deleteWhiteListMemberRequest = async (guid) =>
  commonServiceRequestWrapper((token) => {
    if (!token?.jwt) {
      return false;
    }

    return apiService.delete(`${SERVICE_URL}/api/v1/pwc-employee/${guid}`, {
      withCredentials: false,
      headers: {
        Authorization: `Bearer ${token?.jwt}`,
      },
    });
  });

export const updateWhitelistMemberRequest = async (userInfo = {}) =>
  commonServiceRequestWrapper((token) => {
    if (!token?.jwt || !userInfo.guid) {
      return false;
    }

    return apiService.put(
      `${SERVICE_URL}/api/v1/pwc-employee/${userInfo.guid}`,
      userInfo,
      {
        withCredentials: false,
        headers: {
          Authorization: `Bearer ${token?.jwt}`,
        },
      },
    );
  });

export const getUserPermissionByGuidRequest = async (guid) =>
  commonServiceRequestWrapper((token) => {
    if (!token?.jwt) {
      return [];
    }

    return apiService.get(
      `${SERVICE_URL}/api/v1/pwc-employee/${guid}?perm=1
`,
      {
        withCredentials: false,
        headers: {
          Authorization: `Bearer ${token?.jwt}`,
        },
      },
    );
  });

export const getTeamsNames = async (name) =>
  apiService
    .get(
      `${SERVICE_URL}/api/v2/pwc-employee/searchWhiteListAndRestApi/${(
        name || ''
      )
        // To deal with 404 error
        .replaceAll('/', '')}`,
      {
        headers: {
          Authorization: window.localStorage.getItem('accessToken'),
        },
        withCredentials: false,
      },
    )
    .then((res) => res || null);

export const getTeamsNamesByEmails = async (emails) =>
  apiService
    .post(
      `${SERVICE_URL}/api/v2/pwc-employee/searchWhiteListAndRestApiByEmails`,
      { emails },
      {
        headers: {
          Authorization: window.localStorage.getItem('accessToken'),
        },
        withCredentials: false,
      },
    )
    .then((res) => res || null);

export const logoutFromCommonService = () =>
  apiService.get(`${SERVICE_URL}/auth/v1/logout`, {
    headers: {
      Authorization: window.localStorage.getItem('accessToken'),
      ...getChatbotChatIdLogoutHeaders(),
    },
    withCredentials: false,
  });

export const globalSearchRequest = ({ projectId, searchKeyword }) =>
  apiService.post(`${BASE_URL}/project/searchStaticData/${projectId}`, {
    searchKeyword,
  });

export const getCommentStatus = async (projectId, userId) =>
  apiService
    .get(
      `${SERVICE_URL}/api/v2/commentStatus?app=ma&projectId=${projectId}&userId=${userId}`,
      {
        headers: {
          Authorization: window.localStorage.getItem('accessToken'),
        },
        withCredentials: false,
      },
    )
    .then((res) => res || null);

export const updateCommentStatus = async (projectId, userId, value) =>
  apiService
    .post(
      `${SERVICE_URL}/api/v2/commentStatus`,
      {
        app: 'ma',
        projectId,
        userId,
        emailNotificationFlag: value,
      },
      {
        headers: {
          Authorization: window.localStorage.getItem('accessToken'),
        },
        withCredentials: false,
      },
    )
    .then((res) => res || null);

export const getCommentData = async (commentId) =>
  apiService.get(`${SERVICE_URL}/api/v2/comment/getOne/${commentId}`, {
    headers: {
      Authorization: window.localStorage.getItem('accessToken'),
    },
    withCredentials: false,
  });

export const getPendingRequest = async () =>
  apiService
    .get(`${SERVICE_URL}/api/v2/getPendingRequest`, {
      headers: {
        Authorization: window.localStorage.getItem('accessToken'),
      },
      withCredentials: false,
    })
    .then((res) => res || null);

export const updateRequestStatus = async (requestId, result) =>
  apiService.post(
    `${SERVICE_URL}/api/v2/updateRequestStatus`,
    {
      requestId,
      result,
    },
    {
      headers: {
        Authorization: window.localStorage.getItem('accessToken'),
      },
      withCredentials: false,
    },
  );

export const getSystemColorTheme = () =>
  apiService.get(`${SERVICE_URL}/public/v1/config/theme`, {
    withCredentials: false,
  });
// export const getSystemColorTheme = () => apiService.get(`${SERVICE_URL}/api/v1/config/theme`, {
//   headers: {
//     Authorization: `Bearer ${window.localStorage.getItem('accessToken')}`,
//     // Authorization: window.localStorage.getItem('accessToken'),
//   },
//   withCredentials: false,
// });

export const updateSystemColorTheme = async (theme) =>
  commonServiceRequestWrapper((token) =>
    apiService.post(
      `${SERVICE_URL}/api/v1/config/theme`,
      {
        value: theme,
      },
      {
        headers: {
          Authorization: `Bearer ${token?.jwt}`,
        },
        withCredentials: false,
      },
    ),
  );

export const getVerificationCode = () =>
  apiService.get(`${SERVICE_URL}/api/v2/getVerificationCode`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('accessToken')}`,
    },
    withCredentials: false,
  });

export const checkVerificationCode = (code) =>
  apiService.get(`${SERVICE_URL}/api/v2/checkVerificationCode`, {
    params: {
      code,
    },
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('accessToken')}`,
    },
    withCredentials: false,
  });
